import classnames from 'classnames';
import React, { useState } from 'react';
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import { useDict } from '../../../contexts/LanguageContext';

import ByMonth from './ByMonth';
import TotalIncome from './TotalIncome';

const ListPerformance = (props) => {
    const {
        pastMonthlySummary,
        totalIncome,
        totalExpectedThisMonth,
        isLoading,
    } = props;

    const dict = useDict();

    const [activeTab, setActiveTab] = useState('1');

    return (
        <>
            <div className="performance__listing--mobile">
                <div
                    className="tabs tabs--bordered-bottom list-desktop-notes"
                    style={{ overflowY: 'hidden' }}
                >
                    <div className="tabs__wrap">
                        <Nav tabs>
                            <NavItem>
                                <NavLink
                                    className={classnames({
                                        active: activeTab === '1',
                                    })}
                                    onClick={() => setActiveTab('1')}
                                >
                                    <span style={{ fontWeight: 'bold' }}>
                                        {dict.income}
                                    </span>
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    className={classnames({
                                        active: activeTab === '2',
                                    })}
                                    onClick={() => setActiveTab('2')}
                                >
                                    <span style={{ fontWeight: 'bold' }}>
                                        {dict.history}
                                    </span>
                                </NavLink>
                            </NavItem>
                        </Nav>
                        <TabContent activeTab={activeTab}>
                            <TabPane tabId="1">
                                <TotalIncome totalIncome={totalIncome} />
                                <ByMonth
                                    Income={totalExpectedThisMonth}
                                    Data={dict.expectedIncomeFor}
                                    isLoading={isLoading}
                                />
                            </TabPane>
                            <TabPane tabId="2">
                                <ByMonth
                                    Income={pastMonthlySummary}
                                    Data=""
                                    isLoading={isLoading}
                                />
                            </TabPane>
                        </TabContent>
                    </div>
                </div>
                <div />
            </div>
            <div className="performance__listing--web">
                <div className="mr-3">
                    <div
                        className="tabs tabs--bordered-bottom list-desktop-notes"
                        style={{ overflowY: 'hidden', overflowX: 'hidden' }}
                    >
                        <div className="tabs__wrap">
                            <Nav tabs>
                                <NavItem>
                                    <NavLink
                                        className={classnames({ active: true })}
                                    >
                                        <span
                                            style={{
                                                fontWeight: 'bold',
                                                color: '#264391',
                                            }}
                                        >
                                            {dict.income}
                                        </span>
                                    </NavLink>
                                </NavItem>
                            </Nav>
                            <TabContent activeTab="1">
                                <TabPane tabId="1">
                                    <TotalIncome
                                        totalIncome={totalIncome[0]}
                                        isLoading={isLoading}
                                    />
                                    <ByMonth
                                        Income={totalExpectedThisMonth}
                                        Data={dict.expectedIncomeFor}
                                        isLoading={isLoading}
                                    />
                                </TabPane>
                            </TabContent>
                        </div>
                    </div>
                </div>
                <div className="ml-3">
                    <div
                        className="tabs tabs--bordered-bottom list-desktop-notes"
                        style={{ overflowY: 'hidden' }}
                    >
                        <div className="tabs__wrap">
                            <Nav tabs>
                                <NavItem>
                                    <NavLink
                                        className={classnames({ active: true })}
                                    >
                                        <span
                                            style={{
                                                fontWeight: 'bold',
                                                color: '#264391',
                                            }}
                                        >
                                            {dict.history}
                                        </span>
                                    </NavLink>
                                </NavItem>
                            </Nav>
                            <TabContent activeTab="month_1">
                                <TabPane tabId="month_1">
                                    <ByMonth
                                        Income={pastMonthlySummary}
                                        Data=""
                                        isLoading={isLoading}
                                    />
                                </TabPane>
                            </TabContent>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ListPerformance;
